// extracted by mini-css-extract-plugin
module.exports = {"tree__item":"aside_tree__item__5xQ8y","ol":"aside_ol__XoKOV","tree__label":"aside_tree__label__tn_rw"};